// extracted by mini-css-extract-plugin
export var list = "Section-module--list--48ee8";
export var wrapper = "Section-module--wrapper--e8dc5";